import { Col, Container, Image, Row } from "react-bootstrap";
import type { CourseEvent } from "~/models/courseEvent";

interface Props {
    events: CourseEvent[];
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Same output as date-fns format(dt, 'dd MMM yyyy'), e.g. "05 Nov 2026".
// Reads the date part straight from the ISO string so server and browser render identically.
function formatEventDate(value: string) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value ?? "");
    if (m) return `${m[3]} ${MONTHS[Number(m[2]) - 1]} ${m[1]}`;

    const d = new Date(value);
    if (isNaN(d.getTime())) return value;
    return `${String(d.getDate()).padStart(2, "0")} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

function groupEvents(events: CourseEvent[]) {
    const sorted = [...events].sort((a, b) => {
        if (a.courseReference < b.courseReference)
            return -1;
        if (a.courseReference > b.courseReference)
            return 1;
        return 0;
    });

    return Object.entries(
        sorted.reduce((groups, evnt) => {
            const title = evnt.courseTitle;
            groups[title] = groups[title] ? [...groups[title], evnt] : [evnt];
            return groups;
        }, {} as { [key: string]: CourseEvent[] })
    );
}

export default function UpcomingList({ events }: Props) {
    const groupedEvents = groupEvents(events);

    return (
        <>
            {groupedEvents.map(([group, evnts]) => (
                <Container key={group} className="upcomingList">
                    <Row>
                        <Col xs={3}>
                            <Image src={evnts[0].course.thumbnail} fluid></Image>
                        </Col>
                        <Col>
                            <h3>
                                {group}
                            </h3>
                            <ul>
                                {
                                    evnts && evnts.map(evnt => (
                                        <li key={evnt.id}>
                                            {formatEventDate(evnt.startDt)} -&nbsp;
                                            {evnt.city.name} -&nbsp;
                                            {evnt.soldOut ? (
                                                <span>Sold Out</span>
                                            ) : (
                                                <a href={evnt.bookingUrl} target="_blank">Book Now</a>
                                            )
                                            }
                                        </li>
                                    ))
                                }
                            </ul>
                        </Col>
                    </Row>
                </Container>
            ))}
        </>
    );
}
